/* Heated blanket landing: offer box, gallery, carousel, FAQ, CheckoutChamp redirect */
(function () {
  var cfgEl = document.getElementById('hb-config');
  if (!cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var num = function (v) { var n = parseFloat(String(v || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; };
  var money = function (n) { return '$' + n.toFixed(2); };

  var compare = num(cfg.compare);
  var gifts = (cfg.gifts || []).reduce(function (a, v) { return a + num(v); }, 0);
  var bundles = (cfg.bundles || []).map(function (b) { return { key: String(b.key), units: b.units, price: num(b.price) }; });
  var state = { bundle: bundles[0] ? bundles[0].key : '1', color: (cfg.colors && cfg.colors[0]) || 'Pink' };

  function current() { return bundles.filter(function (b) { return b.key === state.bundle; })[0] || bundles[0]; }

  function render() {
    var b = current();
    if (!b) return;
    var full = compare * b.units;
    var save = full > 0 ? Math.round((1 - b.price / full) * 100) : 0;
    $$('[data-hb-price]').forEach(function (el) { el.textContent = money(b.price); });
    $$('[data-hb-compare]').forEach(function (el) { el.textContent = money(full); });
    $$('[data-hb-save]').forEach(function (el) { el.textContent = 'SAVE ' + save + '%'; });
    $$('[data-hb-units]').forEach(function (el) { el.textContent = b.units === 1 ? '1 blanket' : b.units + ' blankets'; });
    $$('[data-hb-giftvalue]').forEach(function (el) { el.textContent = money(gifts); });
    $$('[data-hb-colorname]').forEach(function (el) { el.textContent = state.color; });
    $$('.hb-bundle').forEach(function (el) {
      var on = el.getAttribute('data-bundle') === state.bundle;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    $$('.hb-color').forEach(function (el) {
      var on = el.getAttribute('data-color') === state.color;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  $$('.hb-bundle').forEach(function (el) {
    el.addEventListener('click', function () { state.bundle = el.getAttribute('data-bundle'); render(); });
  });
  $$('.hb-color').forEach(function (el) {
    el.addEventListener('click', function () { state.color = el.getAttribute('data-color'); render(); });
  });

  /* Add to Cart -> CheckoutChamp, carrying bundle, color and the ad's tracking parameters */
  function checkoutUrl() {
    var base = String(cfg.ccUrl || '').trim();
    if (!base) return '';
    var b = current();
    var params = new URLSearchParams(window.location.search);
    params.set('bundle', b.key);
    params.set('units', String(b.units));
    params.set('color', state.color.toLowerCase().replace(/\s+/g, '-'));
    return base + (base.indexOf('?') === -1 ? '?' : '&') + params.toString();
  }
  $$('[data-hb-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = checkoutUrl();
      if (!url) {
        alert('Checkout link missing: add the CheckoutChamp URL in Customize > Heated landing.');
        return;
      }
      window.location.href = url;
    });
  });

  /* Countdown to local midnight */
  var tH = $('[data-hb-h]'), tM = $('[data-hb-m]'), tS = $('[data-hb-s]');
  function tick() {
    var now = new Date();
    var end = new Date(now); end.setHours(24, 0, 0, 0);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    if (tH) tH.textContent = pad(Math.floor(s / 3600));
    if (tM) tM.textContent = pad(Math.floor((s % 3600) / 60));
    if (tS) tS.textContent = pad(s % 60);
  }
  if (tH) { tick(); setInterval(tick, 1000); }

  /* Ship-by date: next business day */
  var shipEl = $('[data-hb-shipdate]');
  if (shipEl) {
    var d = new Date(); d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    shipEl.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'long', day: 'numeric' });
  }

  /* Gallery */
  var main = $('[data-hb-main]');
  var thumbs = $$('.hb-thumb');
  var gi = 0;
  function showSlide(i) {
    if (!thumbs.length || !main) return;
    gi = (i + thumbs.length) % thumbs.length;
    var src = thumbs[gi].querySelector('img');
    var target = main.querySelector('img');
    if (src && target) {
      target.src = src.getAttribute('data-full') || src.src;
      target.removeAttribute('srcset');
    }
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === gi); });
    thumbs[gi].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
  }
  thumbs.forEach(function (t, k) { t.addEventListener('click', function () { showSlide(k); }); });
  var gp = $('[data-hb-gprev]'), gn = $('[data-hb-gnext]');
  if (gp) gp.addEventListener('click', function () { showSlide(gi - 1); });
  if (gn) gn.addEventListener('click', function () { showSlide(gi + 1); });

  /* Video stage: middle card plays muted on loop while on screen; tap = play with sound from the start / pause.
     Side cards (two per side) come to the middle on tap, arrows or swipe. No other controls. */
  $$('[data-hb-vstage]').forEach(function (stage) {
    var cards = $$('.hb-vcard', stage);
    if (!cards.length) return;
    if (cards.length < 2) stage.classList.add('hb-vstage--single');
    var POS = { '-2': 'is-prev2', '-1': 'is-prev1', '0': 'is-active', '1': 'is-next1', '2': 'is-next2' };
    var cur = 0, inView = false;
    var vid = function (c) { return c.querySelector('video'); };
    var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    cards.forEach(function (c) { var v = vid(c); if (v) { v.muted = true; v.removeAttribute('controls'); } });
    var preview = function (c) {
      var v = vid(c); if (!v) return;
      v.muted = true; c.classList.remove('is-playing');
      if (inView) play(v); else v.pause();
    };
    var render = function () {
      var n = cards.length, half = Math.floor(n / 2);
      cards.forEach(function (c, i) {
        var d = i - cur;
        if (d > half) d -= n;
        if (d < -half) d += n;
        c.classList.remove('is-prev2', 'is-prev1', 'is-active', 'is-next1', 'is-next2');
        if (POS[d]) c.classList.add(POS[d]);
        if (d !== 0) { var v = vid(c); if (v) { v.pause(); v.muted = true; } c.classList.remove('is-playing'); }
      });
      preview(cards[cur]);
    };
    var go = function (k) { cur = ((k % cards.length) + cards.length) % cards.length; render(); };
    var pb = $('.hb-vstage__nav--prev', stage), nb = $('.hb-vstage__nav--next', stage);
    if (pb) pb.addEventListener('click', function () { go(cur - 1); });
    if (nb) nb.addEventListener('click', function () { go(cur + 1); });
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () {
        if (i !== cur) { go(i); return; }
        var v = vid(c); if (!v) return;
        if (v.muted) { v.currentTime = 0; v.muted = false; play(v); c.classList.add('is-playing'); }
        else if (v.paused) { play(v); c.classList.add('is-playing'); }
        else { v.pause(); c.classList.remove('is-playing'); }
      });
    });
    var sx = null, sy = 0;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        inView = es[0].isIntersecting;
        var c = cards[cur], v = vid(c); if (!v) return;
        if (!inView) { v.pause(); c.classList.remove('is-playing'); } else if (v.muted) preview(c);
      }, { threshold: 0.35 }).observe(stage);
    } else { inView = true; }
    document.addEventListener('shopify:block:select', function (e) { var i = cards.indexOf(e.target); if (i >= 0) go(i); });
    render();
  });

  /* Review cards carousel (mobile arrows) */
  $$('.hb-revcar').forEach(function (car) {
    var track = $('.hb-reviews__grid', car);
    var step = function () { var c = track.querySelector('.hb-rev'); return c ? c.getBoundingClientRect().width + 14 : 300; };
    var p = $('.hb-revcar__prev', car), n = $('.hb-revcar__next', car);
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* FAQ tabs */
  $$('.hb-faq__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var cat = tab.getAttribute('data-cat');
      $$('.hb-faq__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
      $$('.hb-faq__card').forEach(function (c) { c.hidden = !(cat === 'all' || c.getAttribute('data-cat') === cat); });
    });
  });

  render();
})();
